import React, { Component, Fragment } from "react";

export default class Radio extends Component {

    constructor(props) {
        super(props);
    }

    render() {
        return (
            <Fragment>
                
                <form onChange={this.props.onChange} className="mt-3">

                    <label>Referência: </label>

                    <div className="form-group">
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" id="mes" name="isacumulado" value="mes" defaultChecked={this.props.radioChecked === "mes" ? true : false} />
                            <label className="form-check-label" for="mes">Mês</label>
                        </div>
                    </div>
                    
                    <div className="form-group">
                        <div className="form-check form-check-inline">
                            <input className="form-check-input" type="radio" id="acumulado" name="isacumulado" value="acumulado" defaultChecked={this.props.radioChecked === "acumulado" ? true : false} />
                            <label className="form-check-label" for="acumulado">Acumulado</label> 
                        </div>
                    </div>
                
                </form>
                
            </Fragment>
        )
    }
}